import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import dayjs from "dayjs";
import store from "store2";
/**
 * 获取URL上的参数，兼容hash
 * @param {*} param
 */
export const getQueryString = param => {
  const reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg) || window.location.hash.substring(window.location.hash.search(/\?/) + 1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
};

/*
 ** 获取当前时间的月初月末
 */
export const monthStartAndEdn = () => {
  let currentDay = new Date();
  currentDay.setDate(1);
  let endDay = new Date(currentDay);
  endDay.setMonth(currentDay.getMonth() + 1);
  endDay.setDate(0);
  return [dayjs(currentDay).format("YYYY-MM-DD") + " 00:00:00", dayjs(endDay).format("YYYY-MM-DD") + " 23:59:59"];
};

/**
 * @param 日期格式化
 * @returns {String}
 */
const formatDate = date => {
  var myyear = date.getFullYear();
  var mymonth = date.getMonth() + 1;
  var myweekday = date.getDate();
  if (mymonth < 10) {
    mymonth = "0" + mymonth;
  }
  if (myweekday < 10) {
    myweekday = "0" + myweekday;
  }
  return myyear + "-" + mymonth + "-" + myweekday;
};

/*
 ** 获取当前时间的一周
 */
export const weekStartAndEnd = () => {
  let now = new Date(); // 当前日期
  let nowDay = now.getDate(); // 当前日
  let nowMonth = now.getMonth(); // 当前月
  let nowDayOfWeek = now.getDay();
  var day = nowDayOfWeek || 7; // 今天本周的第几天
  let start = formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 1 - day));
  let end = formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day));
  return [start + " 00:00:00", end + " 23:59:59"];
};

/*
 ** 时间戳格式化
 */

export const format = time => {
  return dayjs(time).format("YYYY-MM-DD");
};

/*
 ** 根据毫秒级的时间戳换算几分钟前，几天前，几周前等
 */
export const formatMsgTime = dateTimeStamp => {
  let minute = 1000 * 60;
  let hour = minute * 60;
  let day = hour * 24;
  let month = day * 30;
  let now = new Date().getTime();
  let diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return;
  }
  let monthC = diffValue / month;
  let weekC = diffValue / (7 * day);
  let dayC = diffValue / day;
  let hourC = diffValue / hour;
  let minC = diffValue / minute;
  let result = "";
  if (monthC >= 1) {
    result = "" + parseInt(monthC) + $t("hz5x2", "月前");
  } else if (weekC >= 1) {
    result = "" + parseInt(weekC) + $t("et452", "周前");
  } else if (dayC >= 1) {
    result = "" + parseInt(dayC) + $t("fm842", "天前");
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + $t("dz7ty3", "小时前");
  } else if (minC >= 1) {
    result = "" + parseInt(minC) + $t("cq8lw3", "分钟前");
  } else result = $t("eeyo2", "刚刚");
  return result;
};
export function isMobile() {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  let getArr = Agents.filter(i => userAgentInfo.includes(i));
  return getArr.length ? true : false;
}

/**
 * 获取浏览器默认语言
 */

export function getBrowerLang() {
  // const languageType = {
  //   en: "en-US",
  //   zh: "zh-CN",
  //   "zh-CN": "zh-CN",
  //   "zh-TW": "zh-TW",
  //   "zh-HK": "zh-TW",
  // };
  const languageType = {
    en: "en-US",
    zh: "zh-CN",
    "zh-cn": "zh-CN",
    "zh-tw": "zh-TW",
    "zh-CN": "zh-CN",
    "zh-TW": "zh-TW",
    "zh-HK": "zh-TW"
  };
  const browerLang = navigator.language || navigator.userLanguage;
  let enLang = "";
  if (browerLang.indexOf("en") > -1) {
    enLang = "en-US";
  }
  const language = languageType[browerLang] || enLang || "zh-CN";
  console.log("浏览器语言language：", language);
  return language;
}

// 将缓存对象或字符串统一转换为标准语言编码，非法值不会继续传给页面和接口。
export function normalizeLanguageCode(language) {
  let languageCode = language;
  if (languageCode && typeof languageCode === "object") {
    languageCode = languageCode.value || languageCode.lang || languageCode.locale;
  }
  if (typeof languageCode !== "string") return "";
  const match = languageCode.trim().match(/^([a-z]{2,3})-([a-z]{2})$/i);
  return match ? `${match[1].toLowerCase()}-${match[2].toUpperCase()}` : "";
}

// 统一读取当前语言，兼容 Vuex 值、gc-i18n 缓存及历史页面缓存。
export function getCurrentLanguageCode(language) {
  const documentLanguage = typeof document !== "undefined" ? document.documentElement.lang : "";
  const currentLanguage = [language, store.get("I18N_LANGUAGE"), store.get("language"), documentLanguage].map(item => normalizeLanguageCode(item)).find(Boolean);
  return currentLanguage || normalizeLanguageCode(getBrowerLang());
}

// gc-i18n 通过全局切换方法加载远程语言包，返回规范化编码供 Vuex 同步。
export async function changeI18nLanguage(language) {
  const languageCode = normalizeLanguageCode(language);
  if (!languageCode) return "";
  if (typeof window.$changeLocale === "function") {
    await window.$changeLocale(languageCode);
  }
  return languageCode;
}

/*
 * 转换为小写并去除空格，并光标保持不动
 */
export function onInputRange(_this, form, formKey, key) {
  const inputId = document.getElementById(key);
  // 获取当前光标位置
  const cursorPosition = inputId.selectionStart;
  // 转换为小写并去除空格
  form[formKey] = form[formKey].replace(/\s/g, "").toLowerCase();
  // 保持光标位置不变
  _this.$nextTick(() => {
    inputId.setSelectionRange(cursorPosition, cursorPosition);
  });
}

// 判断是否是微信小程序
export const isWeiXinLogin = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // 如果是企业微信环境
    if (ua.match(/wxwork/i) == "wxwork") {
      return false; // 企业微信中打开
    } else {
      return true; // 微信中打开
    }
  } else {
    return false; // 普通浏览器中打开
  }
};

// 判断是不是移动端
export const isMobileJs = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    return true;
  } else {
    return false;
  }
};
export const enterpriseMap = {
  entity_user: {
    // 延迟到渲染时读取，避免语言包加载前将中文结果固化在模块常量中。
    get label() {
      return $t("kgsv2", "用户");
    },
    color: "magenta"
  },
  entity_department: {
    get label() {
      return $t("pgxs2", "部门");
    },
    color: "green"
  },
  entity_position: {
    get label() {
      return $t("g6mu2", "岗位");
    },
    color: "default"
  },
  entity_unit: {
    get label() {
      return $t("ely02", "单位");
    },
    color: "gold"
  }
};
export const unitCategoryMap = [{
  get label() {
    return $t("p8jp2", "酒店");
  },
  value: 5,
  code: "HOTEL"
}, {
  get label() {
    return $t("qhrp2", "餐厅");
  },
  value: 3,
  code: "CATERING_CHAIN_LIKE"
}, {
  get label() {
    return $t("i1ii2", "景点");
  },
  value: 5,
  code: "SCENIC_SPOT"
}, {
  get label() {
    return $t("hvor2", "景区");
  },
  value: 3,
  code: "SCENIC_AREA"
}, {
  get label() {
    return $t("q4f02", "集团");
  },
  value: 5,
  code: "GROUP"
}, {
  get label() {
    return $t("g2qrf54", "管理公司");
  },
  value: 3,
  code: "MANAGE"
}, {
  get label() {
    return $t("mj0rj3", "零售店");
  },
  value: 2,
  code: "CATERING"
}, {
  get label() {
    return $t("q1dy2", "链组");
  },
  value: 5,
  code: "CHAIN"
}, {
  get label() {
    return $t("1pbp04", "GC单位");
  },
  value: 5,
  code: "GC"
}];
export const chunkArray = (arr, chunkSize = 8) => {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
};

/*
 * 返回所有父级路径（从根到目标）
 * 使用示例
 * const result = findNodeWithAncestors(treeData, node => node.id === 4);
 * console.log(result.node);      // 目标节点
 * console.log(result.ancestors); // [父节点, 祖父节点, ...]
 */
export function findNodeWithAncestors(tree, predicate, ancestors = []) {
  for (const node of tree) {
    if (predicate(node)) {
      return {
        node,
        ancestors
      };
    }
    if (node.children) {
      const found = findNodeWithAncestors(node.children, predicate, [...ancestors, node]);
      if (found) return found;
    }
  }
  return null;
}

/*
 * 树形搜索
 */
export function mapTreeJs(key, value, arr) {
  let newarr = [];
  arr.forEach(element => {
    if (element[key].toUpperCase().indexOf(value.toUpperCase()) > -1) {
      // 判断条件
      element.expand = true;
      newarr.push(element);
    } else {
      if (element.children && element.children.length > 0) {
        let redata = mapTreeJs(key, value, element.children);
        if (redata && redata.length > 0) {
          let obj = {
            ...element,
            expand: true,
            children: redata
          };
          newarr.push(obj);
        }
      }
    }
  });
  return newarr;
}

/*
 * 获取目标高度
 * obj:{form, params}: 目标对象
 * contentnId: 总高度Id
 * reductionIds: 需要减去的所有ids
 * fixedHeight: 固定高度
 */
export function initPurposeHeight(_this, obj, contentnId = "", reductionIds = [], fixedHeight = 72) {
  _this.$nextTick(() => {
    let contentnIdE = document.getElementById(contentnId);
    let reductionIdsBoo = reductionIds.every(id => document.getElementById(id));
    if (contentnIdE && reductionIdsBoo) {
      let allHeight = contentnIdE.offsetHeight;
      let reductionIdsHeight = 0;
      reductionIds.forEach(id => {
        let elememt = document.getElementById(id);
        reductionIdsHeight += elememt.offsetHeight;
      });
      obj.form[obj.params] = allHeight - reductionIdsHeight - fixedHeight;
    } else {
      initPurposeHeight(_this, obj, contentnId, reductionIds, fixedHeight);
    }
  });
}
export const highlightHtml = (word, keyword) => {
  if (!keyword) return word;
  return word.replace(new RegExp(keyword, "gi"), match => {
    return `<span class="text-[red]">${match}</span>`;
  });
};
export const stopEventDrawer = _vue => {
  // ========== 全局修复 iView Drawer 右上角关闭按钮 iOS 事件穿透 ==========
  _vue.mixin({
    mounted() {
      this.$nextTick(() => {
        this.fixDrawerCloseBtn();
      });
    },
    methods: {
      fixDrawerCloseBtn() {
        const closeBtns = document.querySelectorAll(".ivu-drawer .ivu-drawer-close");
        closeBtns.forEach(btn => {
          if (!btn._iosFixed) {
            btn._iosFixed = true;

            // 只阻止事件冒泡，不阻止默认行为
            btn.addEventListener("click", e => {
              e.stopPropagation(); // 关键：只阻止穿透，不影响关闭
            });
            btn.addEventListener("touchend", e => {
              e.stopPropagation(); // 解决iOS穿透
            });
          }
        });
      }
    },
    watch: {
      $route: {
        handler() {
          setTimeout(() => this.fixDrawerCloseBtn(), 100);
        },
        immediate: true
      }
    }
  });
  // ============================== 修复结束 ==============================
};
const VIEW_DESIGN_OVERLAY_NAMES = new Set(["Modal", "Drawer"]);
function walkComponentChildren(vm, visitor, visited = new WeakSet()) {
  if (!vm || visited.has(vm)) return;
  visited.add(vm);
  visitor(vm);
  (vm.$children || []).forEach(child => walkComponentChildren(child, visitor, visited));
}

// 路由切换时优先通过组件自身 close/input 逻辑关闭已打开的 Modal / Drawer，
// 避免 keep-alive 页面退场后 transfer 到 body 的浮层仍残留在新页面之上。
export function closeRouteViewDesignOverlays(vm) {
  walkComponentChildren(vm, child => {
    var _child$$options;
    const componentName = child === null || child === void 0 || (_child$$options = child.$options) === null || _child$$options === void 0 ? void 0 : _child$$options.name;
    if (!VIEW_DESIGN_OVERLAY_NAMES.has(componentName)) return;
    const isVisible = Boolean(child.visible || child.value);
    if (!isVisible) return;
    if (typeof child.close === "function") {
      child.close();
      return;
    }
    child.$emit("input", false);
  });
}